import { KendoBaseComponent } from '@progress/kendo-base-components-vue-wrapper'
import SwitchProps from './SwitchProps'
import ObsoleteSwitchProps from './ObsoleteSwitchProps'

import Messages from './Messages'

export default {
    props: Object.assign({}, SwitchProps, ObsoleteSwitchProps),
    render (h) {
        return h('input',{
            attrs: {
                type: 'checkbox'
            }
        })
    },
    mixins: [
        KendoBaseComponent,
        Messages
    ],
    mounted() {
        var that = this

        that.widgetOptions.messages = that.widgetOptions.messages || {}

        // Obsolete props
        if (that.widgetOptions.onLabel) {
            that.widgetOptions.messages.checked = that.widgetOptions.onLabel
        }

        if (that.widgetOptions.offLabel) {
            that.widgetOptions.messages.unchecked = that.widgetOptions.offLabel
        }

        if (that.widgetOptions.enable == false) {
            that.widgetOptions.enabled = that.widgetOptions.enable
        }

        kendo.jQuery(that.$el).kendoSwitch(that.widgetOptions)

        that.$_kendoSwitch = that.kendoWidget()
        that.$emit('kendowidgetready', that.kendoWidget())

        that.kendoWidget().bind('change', function(){
            that.$emit('changemodel', that.kendoWidget().check())
        })
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoSwitch()
        }
    },
    destroyed() {
        var switchInstance=this.kendoWidget() || this.$_kendoSwitch
        switchInstance.destroy()
        switchInstance.wrapper.remove()
    },
    watch: {
        checked: function (value) {
            var kWidget = this.kendoWidget()

            if(value != kWidget.check()){
                kWidget.check(value)
            }
        }
    },
    model: {
        event: 'changemodel',
        prop: 'checked'
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoSwitch/KendoSwitchMixin.js